import { Icon, Row, Text, useAppPalette } from "@bridgesplit/ui";
import { SxProps, Theme } from "@mui/material";

export type TokenListFilterBadgeProps = {
    activeCount: number;
    hasFiltersAvailable: boolean;
    onClick?: () => void;
    sx?: SxProps<Theme>;
};

export function TokenListFilterBadge({ activeCount, hasFiltersAvailable, onClick, sx }: TokenListFilterBadgeProps) {
    const { primary, textSecondary, textDisabled, border, hoverBackground } = useAppPalette();

    const hasActive = activeCount > 0;

    return (
        <Row
            spacing={0.5}
            sx={{
                alignItems: "center",
                px: 1,
                py: 0.5,
                borderRadius: "9999px",
                border: `1px solid ${hasActive ? primary : border}`,
                background: hasActive ? "transparent" : undefined,
                cursor: onClick ? "pointer" : undefined,
                minWidth: 28,
                justifyContent: "center",
                opacity: !hasActive && !hasFiltersAvailable ? 0.6 : 1,
                ":hover": onClick
                    ? {
                          background: hoverBackground
                      }
                    : undefined,
                ...sx
            }}
            onClick={onClick}
        >
            <Icon
                type="filter"
                sx={{
                    fontSize: 14,
                    color: hasActive ? primary : hasFiltersAvailable ? textSecondary : textDisabled
                }}
            />
            <Text
                variant="body2"
                sx={{
                    fontWeight: 600,
                    color: hasActive ? primary : hasFiltersAvailable ? textSecondary : textDisabled
                }}
            >
                {hasActive ? activeCount : hasFiltersAvailable ? "Filters" : "0"}
            </Text>
        </Row>
    );
}
